/* eslint-disable quote-props */
<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="1088px">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="join-inquier-list-product">
        <div class="join-inquier-list-product-title">
          <span>设置关联</span>
          <el-upload
            class="upload-demo"
            :action="actions"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="uploadinterface"
            :before-remove="beforeRemove"
            :on-progress="filehandler"
            :on-success="getSuccess"
            :on-error="getError"
            :headers="Headers"
            :limit="1"
            :disabled="fileList.length === 1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">导入Excle</el-button>
          </el-upload>
          <!-- <el-button type="primary" @click="importTable">导入Excle</el-button> -->
        </div>
        <div class="set-link-table-list">
          <el-form label-width="120px" class="demo-ruleForm">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              border
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="表单表头">
                <template slot-scope="scope">{{ scope.row.type }}</template>
              </el-table-column>
            </el-table>
          </el-form>
          <el-form label-width="120px" class="demo-ruleForm">
            <el-table
              :data="tableData1"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              border
              @header-click="headerClick"
            >
              <el-table-column
                v-for="(item,index) in tableData3"
                :key="index"
                :data-index="index"
                :label="item.bankHeadName"
                :prop="item.bankHeadlabel"
              ></el-table-column>
              <!--  -->
              <!-- <el-table-column prop="date" label="类型"></el-table-column>

              <el-table-column prop="address" label="交易时间"></el-table-column>
              <el-table-column prop="name" label="交易额"></el-table-column>
              <el-table-column prop="address" label="用途"></el-table-column>-->
            </el-table>
          </el-form>
        </div>
        <el-form label-width="120px">
          <el-table
            :data="tableData2"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
            ref="tables"
            border
          >
            <el-table-column prop="date" label="表单表头"></el-table-column>
            <el-table-column prop="TransactionType" label="交易类型"></el-table-column>
            <el-table-column prop="accountnumber" label="付款人银行账号" width="130"></el-table-column>
            <el-table-column prop="payername" label="付款人名称" width="120"></el-table-column>
            <el-table-column prop="bankName" label="付款人开户行名称" width="130"></el-table-column>
            <el-table-column prop="Bankline" label="银行行号"></el-table-column>
            <el-table-column prop="Paymentnumber" label="收款账号"></el-table-column>
            <el-table-column prop="paymentusername" label="收款人名称" width="120"></el-table-column>
            <el-table-column prop="drawee" label="收款人开户行名称" width="130"></el-table-column>
            <el-table-column prop="liuwater" label="交易流水号" width="120"></el-table-column>
            <el-table-column prop="paymoney" label="收款金额"></el-table-column>
            <el-table-column prop="user" label="用途"></el-table-column>
          </el-table>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="close">取 消</el-button>
      </span>
    </div>
  </el-drawer>
</template>
<script>
import { getToken } from '../../../util/auth' // get token from cookie
import { AddBankHeader } from '@/api/system/rightsManagement.js'
import { proAllContent } from '../utils/data'
export default {
  data () {
    return {
      SelectItem: {},
      actions: '',
      headerLine: 9,
      fileList: [],
      drawer: false,
      arrList: [],
      queryParams: {},
      proAllContent: proAllContent,
      tableData: [
        {
          type: '交易类型',
          label: 'TransactionType',
          id: 1
        },
        {
          type: '付款人银行账号',
          label: 'accountnumber',

          id: 2
        },
        {
          type: '付款人名称',

          label: 'payername',
          id: 3
        },
        {
          type: '付款人开户行名称',
          label: 'bankName',
          id: 4
        },
        {
          type: '银行行号',
          label: 'Bankline',
          id: 5
        },
        {
          type: '收款账号',
          label: 'Paymentnumber',
          id: 6
        },
        {
          type: '收款人名称',
          label: 'paymentusername',
          id: 7
        },
        {
          type: '收款人开户行名称',
          label: 'drawee',
          id: 8
        },
        {
          type: '交易流水号',
          label: 'liuwater',
          id: 9
        },
        {
          type: '收款金额',
          label: 'paymoney',
          id: 10
        },
        {
          type: '用途',
          laberl: 'user',
          id: 10
        }
      ],
      multipleSelection: [],
      tableData3: [],
      tableData1: [
      ],
      tableData2: [
        // {
        //   date: '中国银行'
        // }
      ],
      checkItem: {},
      itemSelct: [],
      Headers: {
        // 'Content-type': 'application/x-www-form-urlencoded',
        Authorization: ' Bearer ' + getToken()
      }
    }
  },
  methods: {
    close () {
      this.drawer = false
      this.tableData3 = []
      this.tableData2 = []
      this.multipleSelection = []
    },
    headerClick (column, event) {
      // this.multipleSelect

      if (this.multipleSelection.length > 0) {
        const endIdnex = this.multipleSelection[this.multipleSelection.length - 1]

        this.$refs.tables.columns.forEach((v, i) => {
          if (endIdnex.type === v.label) {
            this.$set(this.tableData2[0], endIdnex.label, column.label)
          }
        })
      }
    },
    uploadinterface (file) {
      const lastIndex = file.name.lastIndexOf('.')
      const endfilename = file.name.substr(lastIndex)
      if (!['.xlsx', '.xls'].includes(endfilename)) {
        this.$message({
          message: '请上传后缀格式为.xlsx或xls的文件',
          type: 'error'
        })
        this.fileList = []
        return false
      }
    },
    getError (res) {
    },
    getSuccess (res) {
      // debugger
      const { code, obj } = res
      this.$message({
        message: res.msg,
        type: res.code === 200 ? 'success' : 'error'
      })
      if (code !== 200) {
        this.fileList = []
        return
      }

      this.checkItem.guid = obj.guid
      // this.tableData3 = obj.systemChinaBankVoList
      this.tableData3 = []
      obj.systemChinaBankVoList.forEach((v, i) => {
        // const endindex = v.bankHeadName.indexOf('[')
        // const startIndex = v.bankHeadName.substring(0, endindex)
        // const startend = v.bankHeadName.substr(endindex)
        this.tableData3.push({
          bankHeadName: v.bankHeadName,
          bankHeadlabel: v.startIndex,
          id: i + 1
        })
      })
      this.fileList = []
    },
    filehandler (event, file, fileList) {
      var formDate = new FormData()
      formDate.append('file', file.raw)
      // debugger
    },
    handleRemove (file, fileList) {
      // debugger
      this.fileList = []
    },
    handlePreview (file) {

    },
    handleExceed (files, fileList) {
      this.$message.error('只能上传一个文件哦')
    },
    beforeRemove (file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`)
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 添加子型号初始化
    onInitialize () {
      this.getProductBaseQueryPageAll()
      this.drawer = true
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 导入Excle
    importTable () {
    },
    // 加入询价单页面初始化
    onInitial (type, list) {
      this.actions = `/api/systemBankHeader/queryFileHeadLine/${list.headLine}`
      this.drawer = true
      // debugger /
      this.tableData2 = []
      // let obj={};
      this.tableData2.push({
        date: list.bankName
      })

      // this.tableData2[0]['date']=list.bankName;
      // this.checkItem.giud=list.giud;
      ;(this.checkItem.bankNames = list.bankName); (this.checkItem.id = list.id)
      ;(this.checkItem.updateDate = list.updateDate);
      (this.checkItem.createUser = list.createUser);
      (this.checkItem.headerLine = list.headLine)
      this.checkItem.createDate = list.createDate
      this.checkItem.createIp = list.createIp
      // this.arrList = list[0].parameterListValue
    },
    // 查看详情
    onDetails () {
      // debugger
      this.$refs.joinInquirySheetRefs.onInitial(this.proAllContent)
    },
    // 确定
    onSubmit () {
      //
      const len = Object.keys(this.tableData2[0]).length
      if (len !== 12) {
        this.$message({
          message: '请导入Excel后关联所有字段',
          type: 'error'
        })
        return false
      }

      /*
       <el-table-column prop="date" label="表单表头"></el-table-column>
            <el-table-column prop="TransactionType" label="交易类型"></el-table-column>
            <el-table-column prop="accountnumber" label="付款人银行账号" width="130"></el-table-column>
            <el-table-column prop="payername" label="付款人名称" width="120"></el-table-column>
            <el-table-column prop="bankName" label="付款人开户行名" width="130"></el-table-column>
            <el-table-column prop="Bankline" label="银行行号"></el-table-column>
            <el-table-column prop="Paymentnumber" label="收款账号"></el-table-column>
            <el-table-column prop="paymentusername" label="收款人名称" width="120"></el-table-column>
            <el-table-column prop="drawee" label="收款人开户行名称" width="130"></el-table-column>
            <el-table-column prop="liuwater" label="交易流水号" width="120"></el-table-column>
            <el-table-column prop="paymoney" label="收款金额"></el-table-column>
            <el-tab'le-column prop="use" label="用途"></el-table-column>

      * */
      const {
        guid,
        headerLine,
        id,
        createIp,
        createUser,
        bankNames,
        updateDate,
        createDate
      } = this.checkItem
      const {
        TransactionType,
        accountnumber,
        payername,
        bankName,
        Bankline,
        Paymentnumber,
        paymentusername,
        drawee,
        liuwater,
        paymoney,
        user
      } = this.tableData2[0]

      // debugger
      const params = {
        bankLineNumber: Bankline,
        bankName: bankNames,
        bankOpenName: bankName,
        batchNumber: liuwater,
        createDate: createDate,
        createIp: createIp,
        createUser: createUser,
        guid: guid,
        headLine: headerLine,
        id: id,
        payBankAccount: accountnumber,
        payName: payername,
        payeeBankOpenName: drawee,
        payeeMoney: paymoney,
        payeeName: paymentusername,
        purpose: user,
        shroffAccount: Paymentnumber,
        tradeType: TransactionType,
        updateDate: updateDate
      }
      AddBankHeader(params).then(res => {
        this.$message({
          message: res.data.msg,
          type: res.data.code !== 200 ? 'error' : 'success'
        })
      })
      this.drawer = false
    },
    // 关闭
    onClose () {
      this.drawer = false
    }
  }
}
</script>
<style  lang="scss" scoped>
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  color: #83878a;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      color: #4e555b;
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 30px;
    .join-inquier-list-product-title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      border-left: 2px solid #276cff;
      height: 30px;
      padding-left: 10px;
      color: #4e555b;
      margin-bottom: 30px;
    }
    .set-link-table-list {
      display: flex;
      width: 100%;
      margin-bottom: 30px;
      .demo-ruleForm:nth-child(1) {
        flex: 1;
        margin-right: 30px;
      }
      .demo-ruleForm:nth-child(2) {
        flex: 5;
      }
    }
  }
  .join-inquiry-list-drawer-parameter {
    font-size: 14px;
    margin-top: 20px;
  }
  .join-inquier-list-like-product {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-col-3 {
      div {
        border: 1px solid #e3ecff;
      }
    }
  }
  .dialog-footer {
    width: 130px;
    margin: 30px auto;
    float: right;
  }
}
</style>
